import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col, Grid, Radio, FormGroup } from 'react-bootstrap';
import { setLoader, setShowError, setErrorType, setData, setImage } from "../../redux/actionCreators";
import './confirmationClauses.css';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';


class ConfirmationClauses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disableButton: true,
            result: {},
            clauses: this.props.stepInfo.clauses || [],
        };

    }

    componentDidMount() {
        this.props.setLoader(false);
    }

    onClickRadio = (question, answer) => {
        const auxResult = Object.assign({}, this.state.result);
        auxResult[question] = answer;
        this.props.setImage(undefined);
        this.props.setData(auxResult);
        this.setState({
            disableButton: !(Object.keys(auxResult).length === this.state.clauses.length),
            result: auxResult,
        });
    }

    getClauses = () => {
        const result = [];
        for (const clause of this.state.clauses) {
            result.push(
                <Col sm={12} key={`clause-${clause.data}`}>
                    <div className='clause'>
                        <p>{clause.label}</p>
                        <FormGroup>
                            {
                                clause.options.map((option) => {
                                    return (
                                        <Radio inline className={'option'}
                                            name={clause.data}
                                            onClick={() => {
                                                    const value = {
                                                        question: clause.label,
                                                        answer: option,
                                                    };
                                                    this.onClickRadio(`${clause.data}`, JSON.stringify(value))
                                                }
                                            }
                                            key={`option-${clause.data}-${option}`}
                                        >
                                            {option}
                                        </Radio>
                                    )
                                })
                            }
                        </FormGroup>
                    </div>
                </Col>
            )
        }
        return result;
    }

    render() {
        return (
            <div className={'confirmation-clauses'}>
                
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <MainButton
                                onClick={this.props.nextStep}
                                disabled={this.state.disableButton}
                                text={this.props.buttonText}
                            />
                        </FooterContainer>
                    )}
                >
                <Grid>
                    <Row>
                        <Col sm={12}>
                            {this.state.clauses.length > 1 ?
                                <p className={'description'}>Antes de continuar, revise con atención y responda las siguientes cláusulas</p>
                                :
                                <p className={'description'}>Antes de continuar, revise con atención y responda la siguiente cláusula</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        {this.getClauses()}
                    </Row>
                
                </Grid>
                </PageWithFooter>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        loader: state.loader,
        showError: state.showError,
        errorType: state.errorType,
        documents: state.documents
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setData(data) {
            dispatch(setData(data));
        },
        setImage(image) {
            dispatch(setImage(image));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationClauses);
